import React from 'react';
import { useRedux } from 'use-redux';
import { setLauncherGuideVisibility } from '@actions/utils';
import Button from '@ui/Button';

const GuideButton = () => {
  const [
    {
      utils: { isUserOnline },
    },
    dispatch,
  ] = useRedux();

  const onLauncherClick = () => {
    if (!isUserOnline) {
      dispatch(setLauncherGuideVisibility(true));
    }
  };

  return (
    <Button
      style={{ padding: '3px 16px', marginLeft: 2, width: 'auto' }}
      color={isUserOnline ? 'green' : 'grey'}
      onClick={onLauncherClick}
    >
      Minecraft
    </Button>
  );
};

export default GuideButton;
